module.exports = __webpack_public_path__ + "img/side seam back pocket position.7840c8b1.png";